/***************************************************************************************************
** isValuePresent
***************************************************************************************************/

export default function isValuePresent(value) {
  return Boolean(value !== undefined && value !== null);
}
